module.exports = __webpack_public_path__ + "img/blackhole.b71058eb.png";